module.exports = __webpack_public_path__ + "img/Steor-Icons-21.456566c7.svg";